import { setMockUser, getCurrentMockUserRole } from '@/utils/mockUsers'

export const resolveUserValue = appStore => appStore.user?.value || appStore.user

export const detectBitrix24Mode = () => {
	const isBitrixIframe = (() => {
		try {
			return window.self !== window.top
		} catch (_) {
			return true
		}
	})()

	return localStorage.getItem('bitrix24_mode') === 'true' || isBitrixIframe
}

export const resolveAuthRoute = isBitrix24Mode =>
	isBitrix24Mode ? '/bitrix24-auth' : '/auth'

export const ensureBitrixEntryRoute = ({ to, next, isBitrix24Mode }) => {
	if (isBitrix24Mode && to.path === '/auth') {
		next('/bitrix24-auth')
		return false
	}

	return true
}

export const ensureAuthentication = async ({
	to,
	next,
	authService,
	appStore,
	devModeActive,
	isBitrix24Mode,
	logger,
}) => {
	if (!to.meta.requiresAuth) {
		return true
	}

	const isAuth = authService.isAuthenticated()

	logger.log('Auth check:', {
		isAuth,
		hasToken: !!localStorage.getItem('access_token'),
		storeUser: appStore.user,
		devMode: devModeActive,
		bitrix24Mode: isBitrix24Mode,
	})

	if (!isAuth && !devModeActive) {
		const authRoute = resolveAuthRoute(isBitrix24Mode)
		next(authRoute)
		return false
	}

	if (!isAuth && devModeActive) {
		const devProfile = getCurrentMockUserRole() || 'student'
		await setMockUser(devProfile, appStore)
	}

	if (isBitrix24Mode && to.path !== '/bitrix24-welcome') {
		const needsPassword = localStorage.getItem('bitrix24_needs_password') === 'true'
		if (needsPassword) {
			next('/bitrix24-welcome')
			return false
		}
	}

	return true
}

export const ensureRoleAccess = async ({
	to,
	next,
	appStore,
	devModeActive,
	isBitrix24Mode,
	logger,
}) => {
	if (!to.meta.roles?.length) {
		return true
	}

	const userValue = resolveUserValue(appStore)
	const hasAccess = Boolean(
		userValue?.roles?.some(role => to.meta.roles.includes(role))
	)

	logger.log('Role check:', {
		requiredRoles: to.meta.roles,
		userValue,
		userRoles: userValue?.roles,
		hasAccess,
	})

	if (hasAccess) {
		return true
	}

	if (devModeActive) {
		const targetRole = to.meta.roles[0]
		await setMockUser(targetRole, appStore)
		return true
	}

	appStore.showError('У вас нет доступа к этой странице')
	next(resolveAuthRoute(isBitrix24Mode))
	return false
}

export const redirectAuthenticatedGuest = ({
	to,
	next,
	authService,
	appStore,
}) => {
	if (
		(to.path !== '/auth' && to.path !== '/bitrix24-auth') ||
		!authService.isAuthenticated()
	) {
		return true
	}

	const userValue = resolveUserValue(appStore)
	if (!userValue?.roles || !userValue?.email) {
		return true
	}

	const isNewUser = userValue.email.includes('.new@')

	if (userValue.roles.includes('admin')) {
		next(isNewUser ? '/admin/new-dashboard' : '/admin/dashboard')
		return false
	}

	if (userValue.roles.includes('teacher')) {
		next('/teacher/dashboard')
		return false
	}

	next('/student-dashboard')
	return false
}
